module.exports = __webpack_public_path__ + "static/media/fistball.15ef1922.svg";